/* eslint-disable array-callback-return */
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Progress, Icon, Tooltip, Alert } from "antd";
import queryString from "query-string";
import {
  uuidv4,
  sendNotification,
  sendNotificationModified,
  normalizeString,
  ValidateAssetExtensionVideo,
  ValidateAssetExtensionAudio,
  ValidateAssetExtensionImage,
  ValidateAssetExtensionFonts,
  ValidateAssetExtensionDocuments
} from "../../utils";
import BunkeyApi from "../../api/BunkeyAPI";
import {
  setSelectItem,
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps
} from "../../actions/ClientAction";
import { getSearchResult } from "../../actions/SearchAction";
import "./UploadFilesV2.css";
import Helper from "../helper/Helper";

import AWS from '../../utils/aws-config.js';
import UploadFile from "../../utils/UploadFile";

import { UPLOAD_MAX_ATTEMPS } from "../../utils/Constants/UploadsConstants";
import fileExtension from "file-extension";
import BunkeyAPI from "../../api/BunkeyAPI";

export class UploadFilesV2 extends Component {
  constructor(props) {
    super(props);

    this.uploadDivRef = React.createRef();
    this.uploadInputRef = React.createRef();

    AWS.config.setPromisesDependency();
    

    this.state = {
      files: [],
      preview: 0,
      theme: {
        background: "#fafafa",
        border: "1px dashed #d9d9d9",
        color: "#000000"
      },
      folderSpaceInBytes: 0
    };
  }

  componentDidMount() {
    const { theme } = this.props;
    this.setState({
      theme:
        theme === "dark"
          ? {
              background: "#69696B",
              border: "1px dashed #69696B",
              color: "#909090"
            }
          : {
              background: "#fafafa",
              border: "1px dashed #d9d9d9",
              color: "#000000"
            }
    });
    this.getSpaceFolder();
  }

  componentDidUpdate(prevProps) {
    const { start } = this.props;
    if (prevProps.start !== start && start) {
      this.handleUploadFiles();
    }
  }

  handleOnChange = e => {
    const { length } = e.target.files;
    const { files, preview, folderSpaceInBytes } = this.state;
    const { clientId, intl, contractedSpace } = this.props;
    e.persist();

    for (let i = 0; i < length; i++) {
      const exists = files.find(
        r =>
          r.name === e.target.files[i].name && r.size === e.target.files[i].size
      );
      if (!exists) {
        const filterName = e.target.files[i].name.substring(
          0,
          e.target.files[i].name.lastIndexOf(".")
        );
        //
        let subTotal = folderSpaceInBytes + preview;
        let subTotalToFixed = (subTotal / Math.pow(2, 30)).toFixed(2);
        if (subTotalToFixed > contractedSpace) {
          this.handleShowWarning();
          return 1;
        }
        this.setState({ preview: e.target.files[i].size + preview });
        this.handleVerifyBeforeCreate(clientId, { name: filterName });
        //
        const ext = e.target.files[i].name.split(".").slice(-1);
        const uuid = uuidv4();
        const s3Name = `${uuid}.${ext}`;
        //
        const newFile = {
          uuid,
          s3Name,
          ext,
          applyRkg: true,
          uploadObject: null,
          file: e.target.files[i],
          name: e.target.files[i].name,
          size: e.target.files[i].size,
          sizeFormat: this.handleFormat(e.target.files[i].size),
          type:
            e.target.files[i].type === "image/x-sony-arw"
              ? "document"
              : e.target.files[i].type,
          state: "waiting",
          progress: 0
        };
        let reader = new FileReader();
        reader.readAsArrayBuffer(e.target.files[i]);
        reader.onloadend = file => {
          if (file.total === 0) {
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "could_not_add_folder" })
            );
          } else {
            this.setState(
              state => ({
                files: [...state.files, newFile]
              }),
              () => {
                this.props.fileListTotal(this.state.files.length);
              }
            );
          }
        };
      }
    }
    this.uploadInputRef.current.value = "";
  };

  handleShowWarning = () => {
    const { intl } = this.props;
    sendNotification(
      "warning",
      intl,
      intl.formatMessage({ id: "space_max_limit" })
    );
  };

  handleFormat = size => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  };

  handleRemoveFile = uuid => {
    const { preview } = this.state;
    let remove = this.state.files.filter(r => r.uuid === uuid)[0].size;
    this.setState({ preview: preview - remove });
    this.setState(
      state => ({
        files: state.files.filter(r => r.uuid !== uuid)
      }),
      () => this.props.fileListTotal(this.state.files.length)
    );
  };

  handleUploadFiles = () => {
    const { clientId, user, clientName } = this.props;
    const { files } = this.state;
    const inProgress = files.filter(r => r.state === "inprogress").length;
    const LIMIT = 3;

    if (inProgress === 0) {
      files
        .filter(r => r.state === "waiting")
        .slice(0, LIMIT)
        .map(file => {
          const uploadObject = new UploadFile(clientId, clientName, user);
          uploadObject
            .checkIsSetAccelerateConfiguration()
            .then(() => {
              uploadObject.startUpload(
                file,
                this.setUploadObject,
                this.setFileProgress,
                this.handleSaveRecord,
                this.setFileError
              );
            })
            .catch(error => {
              console.error("error catch ", error);
            });

          // const fileKey = `${clientId}/${file.s3Name}`
          // let bucket = null

          // switch (process.env.REACT_APP_BUNKEY_ENV) {
          //   case 'pro':
          //     bucket = 'bunkey-prod'
          //     break;
          //   case 'qa':
          //     bucket = 'bunkey-qa'
          //     break;
          //   default:
          //     bucket = 'bunkey-develop'
          //     break;
          // }

          // const s3 = new AWS.S3({ region: 'us-east-2' })
          // s3.getBucketAccelerateConfiguration({ Bucket: bucket }, (err, resp) => {
          //   if (resp.Status !== 'Enabled') {
          //     s3.putBucketAccelerateConfiguration({
          //       AccelerateConfiguration: {
          //         Status: 'Enabled',
          //       },
          //       Bucket: bucket,
          //     }, (err, data) => {
          //       this.startUpload(err, { ...data, file, fileKey, bucket, user, clientName })
          //     });
          //   } else {
          //     this.startUpload(err, { file, fileKey, bucket, user, clientName })
          //   }
          // })
        }); // fin map
    }
  };
  setFileProgress = (file, e) => {
    this.setState(state => ({
      files: state.files.map(r => {
        return {
          ...r,
          state: r.uuid === file.uuid ? "inprogress" : r.state,
          progress:
            r.uuid === file.uuid ? (e.loaded / e.total) * 100 : r.progress
        };
      })
    }));
  };

  setFileError = file => {
    this.setState(
      state => ({
        files: state.files.map(r => {
          return {
            ...r,
            state: r.uuid === file.uuid ? "error" : r.state
          };
        })
      }),

      () => {
        this.props.setQtyFilesError(
          this.state.files.filter(f => f.state === "error").length
        );
        this.handleUploadFiles();
      }
    );
  };

  setUploadObject = (file, upload) => {
    this.setState(state => ({
      files: state.files.map(r => {
        return {
          ...r,
          uploadObject: r.uuid === file.uuid ? upload : r.uploadObject
        };
      })
    }));
  };
  startUpload = async (err, data) => {
    if (err) return;
    const upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: data.bucket,
        Key: data.fileKey,
        Body: data.file.file
      },
      partSize: 5 * 1024 * 1024,
      queueSize: 1,
      tags: [
        { Key: "Content-Disposition", Value: "attachment" },
        { Key: "Content-Type", Value: data.file.type },
        { Key: "x-amz-meta-uuid", Value: data.file.uuid },
        { Key: "ext", Value: data.file.ext },
        { Key: "size", Value: data.file.size },
        { Key: "name", Value: normalizeString(data.file.name) },
        { Key: "user-name", Value: normalizeString(data.user.name) },
        { Key: "client-name", Value: normalizeString(data.clientName) },
        { Key: "applyRkg", Value: data.file.applyRkg }
      ]
    });

    upload
      .on("httpUploadProgress", e => {
        this.setState(state => ({
          files: state.files.map(r => {
            return {
              ...r,
              state: r.uuid === data.file.uuid ? "inprogress" : r.state,
              progress:
                r.uuid === data.file.uuid
                  ? (e.loaded / e.total) * 100
                  : r.progress
            };
          })
        }));
      })
      .promise()
      .then(
        respUpload => {
          const s3 = new AWS.S3();
          s3.putObjectAcl(
            {
              Bucket: data.bucket,
              Key: respUpload.Key,
              ACL: "public-read"
            },
            (err, respAcl) => {
              if (err) console.log(err, err.stack);
              else {
                this.handleSaveRecord({
                  ...data.file,
                  key: respUpload.Key,
                  futureFileURL: respUpload.Location
                });
              }
            }
          );
        },
        err => {
          this.setState(state => ({
            files: state.files.map(r => {
              return {
                ...r,
                state: r.uuid === data.file.uuid ? "error" : r.state
              };
            })
          }));
          this.props.setQtyFilesError(
            this.state.files.filter(f => f.state === "error").length
          );
          this.handleUploadFiles();
        }
      );

    this.setState(state => ({
      files: state.files.map(r => {
        return {
          ...r,
          uploadObject: r.uuid === data.file.uuid ? upload : r.uploadObject
        };
      })
    }));
  };
  getSpaceFolder() {
    const { workclient } = this.props;

    BunkeyAPI({
      url: `/clients/getSpaceFolder`,
      method: "POST",
      data: {
        client: workclient
      }
    })
      .then(resp => {
        if (resp && resp.status === 200) {
          this.setState({
            folderSpace: resp.data.size,
            folderSpaceInBytes: resp.data.size_in_bytes
          });
        }
      })
      .catch(err => {
        console.log("ERR: ", err);
      });
  }

  handleSaveRecord = asset => {
    const {
      clientId,
      user,
      metadata,
      isAssetVersion,
      itemSelected,
      mentionatedUsers,
      intl,
      keyCollection,
      setSelectItem,
      from,
      location,
      getSearchResult,
      workclient,
      searchText,
      searchType,
      orderBy
    } = this.props;
    let typeFile, fileName, nameFile, assetName;

    fileName = asset.name.split(".");
    fileName.pop();
    nameFile = fileName.join(".");
    assetName = asset.name.length > 10 ? asset.name.slice(0, 10) : asset.name;

    if (ValidateAssetExtensionImage(asset.ext[0])) {
      typeFile = "image";
    } else if (ValidateAssetExtensionDocuments(asset.ext[0])) {
      typeFile = "document";
    } else if (ValidateAssetExtensionAudio(asset.ext[0])) {
      typeFile = "audio";
    } else if (ValidateAssetExtensionFonts(asset.ext[0])) {
      typeFile = "font";
    } else if (ValidateAssetExtensionVideo(asset.ext[0])) {
      typeFile = "video";
    } else {
      typeFile = "other";
    }

    if (isAssetVersion) {
      BunkeyApi({
        url: `assetVersion`,
        method: "POST",
        data: {
          documentId: itemSelected.document._id,
          isFinal: false,
          description: "",
          userId: user._id,
          mentionatedUsers,
          document: {
            metadata: {
              descriptiveTags: metadata.tags,
              copyRight: "free",
              type: "final",
              createdDate: metadata.copyright.createDate,
              dueDate: metadata.copyright.dueDate
            },
            name: nameFile,
            fileSize: asset.size,
            fileSizeFormat: asset.sizeFormat,
            uuid: asset.uuid,
            type: typeFile,
            url: asset.futureFileURL
          }
        }
      })
        .then(resp => {
          this.setState(
            state => ({
              files: state.files.map(r => {
                return {
                  ...r,
                  state: r.uuid === asset.uuid ? "success" : r.state
                };
              })
            }),
            () => {
              setSelectItem(
                keyCollection,
                itemSelected.document,
                from,
                itemSelected.document.indice
              );
              //
              if (location.pathname.includes("result")) {
                getSearchResult(workclient, searchText, searchType, 1, orderBy);
              }
              //
              sendNotification(
                "success",
                intl,
                `${intl.formatMessage({
                  id: "the_asset"
                })} ${assetName} ${intl.formatMessage({
                  id: "uploaded_successfully"
                })}`,
                4,
                "topRight"
              );
              //
              this.handleIsDone();
            }
          );
        })
        .catch(err => {
          console.log("error post handleSaveRecord: ", err);
        });
    } else {
      BunkeyApi({
        url: `clients/${clientId}/objects/${metadata.folderId}`,
        method: "POST",
        data: {
          name: nameFile,
          uuid: asset.uuid,
          type: typeFile,
          fileSize: asset.size,
          fileSizeFormat: asset.sizeFormat,
          originalURL: asset.futureFileURL,
          user: user._id,
          metadata: {
            descriptiveTags: metadata.tags,
            copyRight: "free",
            type: "final",
            createdDate: metadata.copyright.createDate,
            dueDate: metadata.copyright.dueDate
          }
        }
      })
        .then(resp => {
          this.setState(
            state => ({
              files: state.files.map(r => {
                return {
                  ...r,
                  state: r.uuid === asset.uuid ? "success" : r.state
                };
              })
            }),
            () => {
              sendNotification(
                "success",
                intl,
                `${intl.formatMessage({
                  id: "the_asset"
                })} ${assetName} ${intl.formatMessage({
                  id: "uploaded_successfully"
                })}`,
                4,
                "topRight"
              );
              const isPdfFile =
                fileExtension(asset.futureFileURL).toLocaleLowerCase() ===
                "pdf";
              if (isPdfFile) {
                sendNotification(
                  "success",
                  intl,
                  intl.formatMessage(
                    { id: "file_sent_to_convertinator" },
                    { fileName: nameFile + ".pdf" }
                  ),
                  null,
                  "topRight"
                );
              }

              this.handleIsDone();
              this.handleUploadFiles();
            }
          );
        })
        .catch(err => {
          console.log("error post handleSaveRecord: ", err);
          // this.props.onError()
          // sendNotification('error', intl, intl.formatMessage({ id: 'try_again' }))
        });
    }
  };

  handleAbort = asset => {
    asset.uploadObject.abort();
    this.setState(
      state => ({
        files: state.files.filter(r => r.uuid !== asset.uuid)
      }),
      () => this.handleIsDone()
    );
  };

  handleRetry = (asset, massive = null) => {
    const { qtyFilesError, numberAttemps } = this.props;
    this.setState(
      state => ({
        files: state.files.map(r => {
          return {
            ...r,
            state: r.uuid === asset.uuid ? "waiting" : r.state,
            progress: r.uuid === asset.uuid ? 0 : r.progress
          };
        })
      }),
      () => {
        this.handleUploadFiles();
        if (!massive && qtyFilesError > 0) {
          this.props.setQtyFilesError(qtyFilesError - 1);
          this.props.setNumberAttemps(numberAttemps + 1);
        }
        this.props.handleUserAttemps(this.handleAttemps([asset], false));
      }
    );
  };

  handleIsDone = () => {
    const { files } = this.state;
    const total = files.length;
    const success = files.filter(r => r.state === "success").length;
    const error = files.filter(r => r.state === "error").length;

    if (total === 0) {
      this.props.isDone(false, false);
    } else {
      if (total === success) {
        this.props.isDone(true, true);
      } else if (total === success + error) {
        this.props.isDone(true, false);
      }
    }
  };

  handleVerifyBeforeCreate = (clientId, data) => {
    const { intl, breadcrumb } = this.props;
    const path = `clients/${clientId}/objects/verifyBeforeCreate?${queryString.stringify(
      data
    )}`;
    BunkeyApi({
      url: path,
      method: "GET",
      data
    })
      .then(resp => {
        if (resp.status === 200 && resp.data.length > 0) {
          let build = [];
          resp.data.map(i => {
            let bread = "";
            let id = "";
            this.handleBreadcrumbs(i, breadcrumb).map(r => {
              bread += `${r.name}/`;
              id = r.id;
            });
            build.push({ name: bread, key: id });
          });
          sendNotificationModified(
            intl,
            intl
              .formatMessage({ id: "there_are_already_files_with_this_name" })
              .replace("#name", data.name),
            build
          );
        }
      })
      .catch(err => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "the_asset_could_not_be_verified" })
        );
      });
  };

  handleBreadcrumbs = (item, breadcrumb) => {
    let route = [];
    item.parents.forEach(itemParents => {
      breadcrumb.forEach(breadElement => {
        if (itemParents === breadElement._id)
          route.push({ id: breadElement._id, name: breadElement.name });
      });
    });
    return route;
  };

  handleTryAgain = () => {
    const { files } = this.state;
    const { qtyFilesError, numberAttemps } = this.props;
    const errorFiles = files.filter(f => f.state === "error");
    const total = qtyFilesError - errorFiles.length;
    this.props.setNumberAttemps(numberAttemps + 1);
    this.props.setQtyFilesError(total);
    errorFiles.forEach(ef => this.handleRetry(ef, true));
  };

  handleAttemps = errorFiles => {
    let errAttemps = [];
    const { attemps } = this.props;
    let aux = attemps.map(am => {
      return am.uuid;
    });
    errAttemps = attemps;
    errorFiles.forEach(f => {
      if (!aux.includes(f.uuid)) {
        const { uuid, name } = f;
        aux.push(uuid);
        errAttemps.push({
          name: name,
          uuid: uuid,
          attemps: 1
        });
      } else {
        errorFiles.forEach(ef => {
          errAttemps.forEach(ea => {
            if (ef.uuid === ea.uuid) {
              ea.attemps = ea.attemps + 1;
            }
          });
        });
        errAttemps = attemps;
      }
    });
    return errAttemps;
  };

  render() {
    const { files, theme } = this.state;
    const {
      intl,
      isMultiple,
      qtyFilesError,
      start,
      numberAttemps,
      quitOrCancel
    } = this.props;
    const successUploads = files.filter(f => f.state === "success").length;
    const errorUploads = files.filter(f => f.state === "error").length;
    let showReport = start || qtyFilesError > 0;
    if (!showReport && numberAttemps > 0) showReport = true;
    return (
      <React.Fragment>
        {!showReport && (
          <Helper
            title={"helper_title"}
            content={"helper_upload_files"}
            trigger={`click`}
          />
        )}
        {!showReport && (
          <div
            className="upload-files-v2"
            ref={this.uploadDivRef}
            style={theme}
          >
            <input
              type="file"
              ref={this.uploadInputRef}
              multiple={isMultiple}
              onChange={this.handleOnChange}
            />
            <div style={{ marginTop: 30 }}>
              <div
                data-icon="v"
                className="icon"
                style={{ fontSize: "40px" }}
              ></div>
            </div>
            <p style={{ color: theme.color, fontSize: 16 }}>
              {intl.formatMessage({ id: "upload_drag_text" })}
            </p>
          </div>
        )}
        {showReport && (
          <div>
            <hr style={{ marginTop: "6px" }}></hr>
            <p style={{ marginBottom: "0px" }}>
              {intl.formatMessage({ id: "uploaded_correctly" })}{" "}
              {successUploads} asset/s
            </p>
            <p style={{ marginBottom: "0px" }}>
              {errorUploads === 0 && <span>&nbsp;</span>}
              {errorUploads > 0 && (
                <span>
                  {intl.formatMessage({ id: "impossible_to_climb" })}{" "}
                  {errorUploads} asset/s.&nbsp;
                  <span
                    onClick={this.handleTryAgain}
                    style={{ color: "#2e97cf", cursor: "pointer" }}
                  >
                    {intl.formatMessage({ id: "upload_try_again" })}
                  </span>
                  &nbsp;
                  {intl.locale === "es" ? "o" : "or"}&nbsp;
                  <span
                    onClick={quitOrCancel}
                    style={{ color: "#2e97cf", cursor: "pointer" }}
                  >
                    {intl.formatMessage({ id: "quit" }).toLowerCase()}
                  </span>
                </span>
              )}
            </p>
            {numberAttemps >= UPLOAD_MAX_ATTEMPS && (
              <Alert
                message={"Error"}
                description={
                  <span>
                    <span>
                      {intl.formatMessage({ id: "error_max_attemps" })}
                    </span>
                    <a href={"mailto:soporte@bunkey.tv"}> soporte@bunkey.tv</a>
                  </span>
                }
                type="warning"
                style={{ marginBottom: 0, marginTop: 5 }}
                showIcon
              />
            )}
          </div>
        )}

        <div style={{ paddingTop: 10, overflow: "auto", maxHeight: "220px" }}>
          {files.map((r, k) => (
            <div key={k}>
              <div
                style={{
                  display: "flex",
                  color: theme.color,
                  justifyContent: "space-between",
                  marginBottom: -10
                }}
              >
                <span>
                  {r.name.length > 40
                    ? `${r.name.substring(0, 37)}...`
                    : r.name}{" "}
                  ({r.sizeFormat})
                </span>
                {r.state === "inprogress" && (
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "cancel_upload" })}
                  >
                    <Icon
                      type="close-circle"
                      style={{ marginRight: 2 }}
                      onClick={() => {
                        this.handleAbort(r);
                      }}
                    />
                  </Tooltip>
                )}
                {r.state === "waiting" && (
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "quit" })}
                  >
                    <Icon
                      type="delete"
                      style={{ marginRight: 2 }}
                      onClick={() => {
                        this.handleRemoveFile(r.uuid);
                      }}
                    />
                  </Tooltip>
                )}
                {r.state === "success" && (
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "success_upload" })}
                  >
                    <Icon type="check-circle" style={{ marginRight: 2 }} />
                  </Tooltip>
                )}
                {r.state === "error" && (
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "error_upload" })}
                  >
                    <Icon
                      type="reload"
                      style={{ marginRight: 2 }}
                      onClick={() => {
                        this.handleRetry(r);
                      }}
                    />
                  </Tooltip>
                )}
              </div>
              <Progress
                percent={r.progress}
                size="small"
                status={
                  r.state === "inprogress"
                    ? "active"
                    : r.state === "error"
                    ? "exception"
                    : "success"
                }
                strokeWidth={4}
                showInfo={false}
              />
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.authUser.token.accessToken,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    user: state.authUser.user,
    workclient: state.client.workclient,
    searchText: state.searcher.searchText,
    searchType: state.searcher.searchType,
    orderBy: state.searcher.orderBy,
    breadcrumb: state.client.breadcrumb,
    qtyFilesError: state.client.qtyFilesError,
    attemps: state.client.attemps,
    numberAttemps: state.client.numberAttemps,
    contractedSpace:
      state.client && state.client.data
        ? state.client.data.contractedSpace
        : null
  };
};

const mapDispatchToProps = {
  setSelectItem,
  getSearchResult,
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFilesV2))
);
